export default __webpack_public_path__ + "static/ARROZ-bc06201270ab4787898b1b78ecc2f48a.jpg";